import { useSite } from "./context"
import Modal from 'react-modal'

export const SiteModal = () => {
    const { modalVisible, modalContent, hideModal, modalLoading} = useSite()

    return <Modal style={customStyles} isOpen={modalVisible} onRequestClose={hideModal}>
        {modalLoading && <>Loading...</>}
        {!modalLoading && <>{modalContent}</>}
        <a style={{display: "block",
            marginTop: "2rem",
            textAlign: "center"
        }} 
            onClick={(e) =>{ e.preventDefault(); hideModal()}}
        href={"#"}>Close</a>
    </Modal>
}

const customStyles = {
    position: "relative",
    zIndex:1000,
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };